import LayersIcon from '@material-ui/icons/Layers';

import DocumentTypeList from './DocumentTypeList';
import DocumentTypeCreate from './DocumentTypeCreate';
import DocumentTypeEdit from './DocumentTypeEdit';

export default {
  list: DocumentTypeList,
  create: DocumentTypeCreate,
  edit: DocumentTypeEdit,
  icon: LayersIcon
};
